import { h } from 'preact';
import CustomersApp from './customers-app';
import LaunchpadApp from './launchpad-app';
import LegacyApp from './legacy-app';
import UserProfileApp from './user-profile-app';

function createPlaygroundRoutes(deps) {
  return [
    {
      path: '/playground/customers',
      element: <CustomersApp deps={deps} />,
    },
    {
      path: '/playground/launchpad',
      element: <LaunchpadApp deps={deps} />,
    },
    {
      path: '/playground/user-profile',
      element: <UserProfileApp deps={deps} />,
    },
    {
      path: '/playground/:appName',
      element: <LegacyApp deps={deps} />,
    },
  ];
}

export default createPlaygroundRoutes;
